<template>
    <div class="month-list">
        <div
            v-for="(el, index) in countMonths"
            :key="index"
            class="elem"
            :class="{ selected: el.isSelected }"
            @click="clickItem(index)"
        >
            <div class="month-item">
                <div class="month-count">
                    <span class="number-count">{{ el.count }}/</span>
                    <span>
                        {{ $t(`components.tariffs.months.${el.count}`) }}
                    </span>
                </div>

                <div class="month-discount">
                    {{ $t(`components.tariffs.month_discount`) }} {{ discountPrice[`month${el.count}`] }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import tariffPackages from "@/data/tariffPackages.json";

const { discountPrice } = tariffPackages;

export default {
    data() {
        return {
            discountPrice,
            countMonths: [
                {
                    count: 1,
                    isSelected: false,
                },
                {
                    count: 3,
                    isSelected: false,
                },
                {
                    count: 6,
                    isSelected: false,
                },
                {
                    count: 12,
                    isSelected: false,
                },
            ],
        };
    },
    props: {
        countMonth: {
            type: Number,
        },
    },

    computed: {
        countMonthState() {
            if (this.countMonth) {
                const res = this.countMonths.find(
                    ({ count }) => count === this.countMonth
                );
                res.isSelected = true;
                return res.count;
            }
        },
    },

    methods: {
        clickItem(index) {
            this.countMonths.forEach((month) => {
                month.isSelected = false;
            });
            this.countMonths[index].isSelected = true;
            this.$emit("onMonthsButton", this.countMonths[index].count);
        },
    },

    mounted() {
        const res = this.countMonth;
        this.countMonths.find(
            ({ count }) => count === this.countMonth
        ).isSelected = true;
        // this.clickItem(
        //     this.countMonths.findIndex(
        //         ({ count }) => count === this.countMonth
        //     )
        // );
    },
};
</script>

<style scoped lang="scss">
.el {
    margin: 0;
}

.month-discount {
    font-size: 14px;
    line-height: 16px;
    font-weight: 500;
}

.number-count {
    font-size: 20px;
    line-height: 30px;
    font-weight: 500;
    color: var(--general-color);
}

.month-item {
    background-color: var(--block-color);
    padding: 7px;
    border-radius: 7px;
    display: flex;
    gap: 10px;
    align-items: center;
    font-family: Gilroy;
    min-width: 235px;
    border: 1px solid transparent;
    font-weight: 500;
    cursor: pointer;
}

.elem {
    padding: 1px;
    border-radius: 7px;
    background: linear-gradient(to bottom, transparent 0%, transparent 100%);
    flex: 1;

    &.selected {
        background: linear-gradient(to bottom, #27a6e5 0%, #7a70df 100%);
    }
}


.month-list {
    display: flex;
    width: 100%;
    flex-wrap: wrap;
    justify-content: center;
    gap: 20px;
}

.month-count {
    background-color: white;
    padding: 5px 10px;
    border-radius: 7px;
}

@media screen and (min-width:800px) and (max-width:1680px) {
    .month-list {
        gap: 20px;
    }

    .elem,
    .month-item {
        // flex-wrap: wrap;
        width: 100px;
    }

    .month-item {
        min-width: auto;
        width: 100%;
        flex-direction: column;
        gap: 10px;

        .month-discount {
            margin-bottom: 5px;
        }
    }

}

@media screen and (max-width:680px) {

    .elem {
        flex: 40%
    }

    .month-item {
        min-width: 135px;
        width: 100%;
        flex-direction: column;
        gap: 10px;

        .month-discount {
            margin-bottom: 5px;
        }
    }
}

@media screen and (max-width:450px) and (min-width: 375px) {
    .elem {
        flex: 100%
    }

    .month-item {
        flex-direction: row;
    }
}
</style>

